import { ACTION } from '@/store/ACTION';

class PromoElementsController {
  hidePromoElements(): void {
    if (!this.store.promo.hasPromoApp()) return;

    this.hidePanelIcon();
    this.hideMenu();
    this.hideProgressBar();
  }

  showPromoElements(): void {
    if (!this.store.promo.hasPromoApp()) return;

    this.showPanelIcon();
    this.showMenu();
    this.showProgressBar();
  }

  hidePanelIcon(): void {
    if (!this.store.promo.hasPromoApp()) return;

    promoApp.eventEmitter.emit(ACTION.HIDE_PANEL_ICON);
  }

  hideMenu(): void {
    if (!this.store.promo.hasPromoApp()) return;

    promoApp.eventEmitter.emit(ACTION.HIDE_MENU);
  }

  hideProgressBar(): void {
    if (!this.store.promo.hasPromoApp()) return;

    promoApp.eventEmitter.emit(ACTION.HIDE_PROGRESS_BAR);
  }

  showPanelIcon(): void {
    if (!this.store.promo.hasPromoApp()) return;

    promoApp.eventEmitter.emit(ACTION.SHOW_PANEL_ICON);
  }

  showMenu(): void {
    if (!this.store.promo.hasPromoApp()) return;

    promoApp.eventEmitter.emit(ACTION.SHOW_MENU);
  }

  showProgressBar(): void {
    if (!this.store.promo.hasPromoApp() || this.isOtherGameFreeSpins()) return;

    promoApp.eventEmitter.emit(ACTION.SHOW_PROGRESS_BAR);
  }

  systemPopupController({ status }: { status: number }): void {
    if (status || (!this.isMainGame() && !this.store.promo.isStartPromo)) {
      this.hidePromoElements();
      return;
    }
    this.showProgressBar();
    if (this.store.promo.isStartPromo) this.showPanelIcon();
  }

  protected isOtherGameFreeSpins(): boolean {
    return (
      this.store.promo.isPopupFreeSpinsOtherGame ||
      this.store.promo.startFreeSpinsOtherGame ||
      this.store.promo.freeSpinsWinInOtherGame
    );
  }

  isMainGame(): boolean {
    return (
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.freeSpinsGame.isStarted() &&
      !this.store.gameData.bonusGame.isPlaying() &&
      !this.store.gameData.bonusGame.isStarted() &&
      (this.store.promo.isTournament ||
        this.store.promo.isAchievement ||
        this.store.promo.isAchievementBG ||
        this.store.promo.isAchievementFS ||
        this.store.promo.isFreeRounds)
    );
  }

  get store() {
    return game.store;
  }
}

export { PromoElementsController };
